import {Component} from '@angular/core';

@Component({
  selector: 'iaud-audit-nav-bar',
  templateUrl: './audit-nav-bar.component.html',
  styleUrls: ['./audit-nav-bar.component.scss'],
})
export class AuditNavBarComponent {

}
